import type { BuyerCreditBalance } from "./properties";
import { formatMinorCurrency } from "./currencyFormat";

// The header user-section credit label ("£100 credit available"), or null when
// there is nothing to show — a null label means the badge and dropdown row do
// not render at all (fails closed). Unlike creditHintMessage (which formats the
// single credit checkout would apply), the header states the buyer's summed
// balance: it answers "what do I hold", not "what will this checkout charge".
// Pure so the visibility + formatting rules are unit tested without the header.
export function creditIndicatorLabel(
  balance: BuyerCreditBalance | null | undefined
): string | null {
  if (!balance || balance.available !== true || !(balance.amount > 0)) {
    return null;
  }
  return `${formatMinorCurrency(balance.amount, balance.currency)} credit available`;
}
